/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { LowestPriceForFlights } from '../../models/lowest-price-for-flights';
import { PostPricesForFlightsRequest } from '../../models/post-prices-for-flights-request';

export interface PostPricesForFlights$Params {
      body: PostPricesForFlightsRequest
}

export function postPricesForFlights(http: HttpClient, rootUrl: string, params: PostPricesForFlights$Params, context?: HttpContext): Observable<DapiHttpResponse<LowestPriceForFlights>> {
  const rb = new DapiRequestBuilder(rootUrl, postPricesForFlights.PATH, 'post');

  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<LowestPriceForFlights>;
    }),
    catchErrorAsJson()
  );
}

postPricesForFlights.PATH = '/api/instantsearch/prices/flights';
